// General
import React, { Component } from 'react';
import PropTypes from 'prop-types';

// Redux Form
import { Field, reduxForm, formValueSelector } from 'redux-form';

// Redux
import { connect } from 'react-redux';

// Translation
import { injectIntl, FormattedMessage } from 'react-intl';

// Locale
import messages from '../../locale/messages';

// Style
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import cx from 'classnames';
import {
  Grid,
  Button,
  Row,
  FormGroup,
  Col,
  FormControl
} from 'react-bootstrap';
import s from './ListPlaceStep1.css';
import bt from '../../components/commonStyle.css';

// Internal Component
import PhotosUpload from '../PhotosUpload';

// Validate
import updateStep2 from './updateStep2';

// Helpers
import validateStep2 from './validateStep2';
import { toastr } from 'react-redux-toastr';
import matterport from '../../helpers/matterport';

class Photos extends Component {

  static propTypes = {
    previousPage: PropTypes.any,
    nextPage: PropTypes.any,
    listId: PropTypes.number.isRequired,
    photosCount: PropTypes.number,
  };

  static defaultProps = {
    matterportURL: ''
  };

  constructor(props) {
    super(props);
    this.state = {
      MatterportMsg: '',
      isAvailable: false
    };
    this.handleMatterportChange = this.handleMatterportChange.bind(this);
  }

  componentWillMount() {
    const { matterportURL, photosCount } = this.props;

    //this.handleMatterportChange(matterportURL);

    if (photosCount > 0) {
      this.setState({ isAvailable: true });
    }
  }

  componentWillReceiveProps(nextProps) {
    const { matterportURL, photosCount } = nextProps;

    //this.handleMatterportChange(matterportURL);

    if (photosCount > 0) {
      this.setState({ isAvailable: true });
    } else {
      this.setState({ isAvailable: false });
    }
  }

  handleCoverImage = () => {
    const { matterportURL, coverPhoto, nextPage } = this.props;
    var errors = false;
    var matterportTest = matterport.validate(matterportURL);
    if (!matterportTest.status) {
      errors = true;
      toastr.error('Error:', 'Please Set a Valid Matterport Link or Do Not Enter a Matterport Link');
    }
    if (!coverPhoto) {
      errors = true;
      toastr.error('Error:', 'Please Set the Cover Photo for your listing');
    }
    if( !errors ) nextPage("description");
  }

  handleMatterportChange(event) {
    var test = matterport.validate(event.target.value);
    this.setState({
      MatterportMsg: test.msg
    });
  }

  renderFormControl = ({ input, label, type, meta: { touched, error }, className }) => {
    //const { formatMessage } = this.props.intl;
    return (
      <div>
        <FormControl {...input} placeholder={label} type={type} className={className} maxLength={255} />
        {touched && error && <span className={s.errorMessage}>{formatMessage(error)}</span>}
      </div>
    )
  }

  render() {
    const { error, handleSubmit, submitting, dispatch, nextPage, previousPage, listId } = this.props;
    const { isAvailable, MatterportMsg } = this.state;
    const { formatMessage } = this.props.intl;
    return (
      <Grid fluid>
        <Row className={cx(s.landingContainer, s.landingContainerPhotsSection)}>
          <Col xs={12} sm={12} md={12} lg={12} className={s.landingContent}>
            <div>
              <form>
              <h3 className={s.landingContentTitle}>Matterport</h3>
              {
                MatterportMsg && <p className={s.maximumCharColor}>
                    {MatterportMsg}
                </p>
              }
              <FormGroup className={s.formGroup}>
                <Field name="matterportURL"
                  type="text"
                  component={this.renderFormControl}
                  label="Matterport URL"
                  className={cx(bt.commonControlInput)}
                  onChange={this.handleMatterportChange}
                />
              </FormGroup>
              <h3 className={s.landingContentTitle}><FormattedMessage {...messages.photos} /></h3>
                <div className={s.landingMainContent}>
                  <FormGroup className={s.formGroup}>
                    <PhotosUpload listId={listId} placeholder={formatMessage(messages.photosPlaceholder)} />
                  </FormGroup>
                </div>
                <div className={cx(s.nextPosition, s.nextPositionMap, s.nextPositionMapPhotos)}>
                  <div className={s.nextBackButtonMap}>
                    <FormGroup className={s.formGroup}>
                      <Col xs={12} sm={12} md={12} lg={12} className={cx(s.noPadding, bt.displatFlexListing, s.continueBtn)}>
                        <Button className={cx(bt.backBtnListing, s.pullLeft, 'floatRight')} onClick={() => previousPage("home")}>
                          <FormattedMessage {...messages.back} />
                        </Button>
                        {
                          !isAvailable && <Button className={cx(bt.continueBtnListing, s.pullRight, 'floatLeft')} onClick={() => nextPage("description")}>
                            <FormattedMessage {...messages.skip} />
                          </Button>
                        }
                        {
                          isAvailable && <Button className={cx(bt.continueBtnListing, s.pullRight, 'floatLeft')} onClick={this.handleCoverImage}>
                            <FormattedMessage {...messages.continue} />
                          </Button>
                        }
                      </Col>
                    </FormGroup>
                  </div>
                </div>
              </form>
            </div>
          </Col>
        </Row>
      </Grid>
    );
  }
}

Photos = reduxForm({
  form: 'ListPlaceStep2', // a unique name for this form
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  onSubmit: updateStep2,
  validate: validateStep2,
})(Photos);

const selector = formValueSelector('ListPlaceStep2');

const mapState = (state) => ({
  matterportURL: selector(state, 'matterportURL'),
  photosCount: state.location.photosCount,
  coverPhoto: selector(state, 'coverPhoto'),
});
const mapDispatch = {};

export default injectIntl(withStyles(s, bt)(connect(mapState, mapDispatch)(Photos)));


// WEBPACK FOOTER //
// src/components/ListPlaceStep1/Photos.js